import { ISelectProps, Select } from "@/eworkitComponents";

import { withFormikField } from "./withFormikField";

export const FormikSelect = withFormikField<ISelectProps>(Select);
